import DefaultLayout from '@/layouts/DefaultLayout.vue'

const Test = () => import('@/pages/Test.vue')


export default {
    path: '/test',
    component: DefaultLayout,
    children: [
        {
            path: '',
            name:'Тест',
            meta:{
                title:'Тест по истории удмуртского языка'
            },
            component: Test
        }
    ]
}